import { CentralServiceResources as cs } from 'se-resource-types'

export class HouseholdPermissionService {
  public account: cs.Households.UserProfilesResult
  private _profiles: cs.Households.UserProfile[]

  public get user(): cs.Accounts.User {
    return this.account?.user
  }

  public get profiles(): cs.Households.UserProfile[] {
    if (this._profiles) return this._profiles

    this._profiles = this.account?.profiles
    return this._profiles
  }

  public get selfIsAdult(): boolean {
    return this.selfProfile?.persona?.age >= 18
  }

  public get selfProfile(): cs.Households.UserProfile {
    return this.profiles.find(p => p.relationship === 'self')
  }

  public get managedProfiles(): cs.Households.UserProfile[] {
    return this.profiles.filter(p => ['manager', 'owner'].includes(p.access))
  }

  public get managedOtherProfiles(): cs.Households.UserProfile[] {
    return this.profiles.filter(p => p.relationship !== 'self' &&
      ['manager', 'owner'].includes(p.access)
    )
  }

  public set profiles(p: cs.Households.UserProfile[]) {
    this._profiles = p
  }

  public static forProfiles(profiles: cs.Households.UserProfile[]): HouseholdPermissionService {
    const permService = new HouseholdPermissionService()
    permService.profiles = profiles
    return permService
  }

  public static forAccount(account: cs.Households.UserProfilesResult): HouseholdPermissionService {
    const permService = new HouseholdPermissionService()
    permService.account = account
    return permService
  }
}
